var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info.isad==1)?_c('div',{staticClass:"NoticeBar"},[_c('van-notice-bar',{attrs:{"left-icon":"volume-o","scrollable":"","mode":"closeable"}},[_vm._v(_vm._s(_vm.info.adcontent))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }